import React from 'react';
import {Link} from 'react-router-dom';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import Types from "constants/Types";

import {Button} from "reactstrap";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import ListItemText from "@material-ui/core/ListItemText";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import API from "@beardeddevops/react.api";

export default class Leep extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {

		let breadcrumbs = [
			{
				name: 'Dashboard',
				url: '/',
				icon: 'dashboard',
			},
			{
				name: 'Dispositions',
				url: '/dispositions',
				icon: 'upload',
			},
			{
				name: 'Pending 4473s',
				url: '/dispositions/pendings',
				icon: 'ellipsis-h',
			},
			{
				name: 'Page Two',
				url: `/dispositions/pendings/${this.props.id}`,
				icon: 'file-pdf-o',
			},
		].slice().concat([
			{
				name: 'Assisted Leep',
				url: `/dispositions/pendings/${this.props.id}/leep`,
				icon: 'file-pdf-o',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					<Link to={`/dispositions/pendings/${this.props.id}`}>
						<Button style={{color: 'white'}} className="btn btn-sm blue-hoki">
							<i className="fa fa-arrow-left"/>&nbsp;&nbsp;Return to 4473 Review
						</Button>
					</Link>
				</Framework.Components.PageBar>

					<Objects.DispositionLeep
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						kiosks={this.props.kiosks}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						showCustomers={this.handleShowCustomers}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						leepUsername={this.props.leepUsername}
						leepPassword={this.props.leepPassword}
					/>

			</div>
		);
	}
}